module.exports = __webpack_public_path__ + "img/office_marker.b3e6a791.svg";